import { Modal } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  .ant-modal-title {
    font-weight: 600 !important;
  }
  .ant-modal-header {
    padding: 16px 24px !important;
  }
`;